"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["href"];
const _hoisted_2 = { class: "role-form-container" };
const _hoisted_3 = {
    class: "oplus-form-text",
    for: "role-name"
};
const _hoisted_4 = { class: "color-box-pos" };
const _hoisted_5 = { class: "role-form-color-text" };
const _hoisted_6 = {
    class: "oplus-form-text",
    for: "role-purpose"
};
const _hoisted_7 = { class: "form-padding" };
const _hoisted_8 = {
    class: "role-flex-wrapper",
    "data-columns": "2"
};
const _hoisted_9 = { class: "role-flex-child-wrap" };
const _hoisted_10 = {
    class: "oplus-form-text",
    for: "role-from"
};
const _hoisted_11 = ["value"];
const _hoisted_12 = {
    class: "oplus-form-text",
    for: "role-to"
};
const _hoisted_13 = ["value"];
const _hoisted_14 = {
    class: "oplus-form-text",
    for: "role-rest"
};
const _hoisted_15 = ["value"];
const _hoisted_16 = ["disabled"];
const _hoisted_17 = { class: "role-flex-child-wrap flex-column" };
const _hoisted_18 = { class: "role-setting-header" };
const _hoisted_19 = {
    key: 0,
    class: "pro-auto-lock tooltip",
    "data-tooltip": "この機能は、\n自動作成のアップグレード\nが必要となります。"
};
const _hoisted_20 = { class: "padding-top dropdown" };
const _hoisted_21 = {
    class: "shift-dropdown dropdown-toggle",
    tabindex: "0"
};
const _hoisted_22 = { class: "shift-dropdown-text" };
const _hoisted_23 = { class: "shift-dropdown-menu menu" };
const _hoisted_24 = { class: "shift-select-items" };
const _hoisted_25 = { class: "role-flex-child-wrap flex-column" };
const _hoisted_26 = {
    class: "role-flex-wrapper",
    "data-columns": "2"
};
const _hoisted_27 = { class: "padding-top dropdown" };
const _hoisted_28 = {
    class: "shift-dropdown dropdown-toggle",
    tabindex: "0"
};
const _hoisted_29 = { class: "shift-dropdown-text" };
const _hoisted_30 = { class: "shift-dropdown-menu menu" };
const _hoisted_31 = { class: "shift-select-items" };
const _hoisted_32 = ["onClick"];
const _hoisted_33 = { class: "role-flex-child-wrap flex-column" };
const _hoisted_34 = {
    class: "padding-top role-flex-wrapper",
    "data-columns": "2"
};
const _hoisted_35 = { class: "flex-column" };
const _hoisted_36 = { class: "oplus-form-checkbox" };
const _hoisted_37 = { class: "oplus-form-checkbox" };
const _hoisted_38 = { class: "oplus-form-checkbox" };
const _hoisted_39 = { class: "oplus-form-checkbox" };
const _hoisted_40 = {
    class: "padding-top role-flex-wrapper",
    "data-columns": "2"
};
const _hoisted_41 = { class: "flex-column" };
const _hoisted_42 = ["disabled"];
const _hoisted_43 = { class: "oplus-form-checkbox" };
const _hoisted_44 = {
    class: "oplus-form-number",
    for: "role-modal-holiday-type"
};
const _hoisted_45 = { class: "flex-start-align-center" };
const _hoisted_46 = {
    key: 0,
    class: "circle-question tooltip",
    "data-tooltip": "この機能をご利用の場合は、\n設定画面にてKOTの連携設定を\n行ってください。"
};
const _hoisted_47 = {
    key: 1,
    class: "role-kot-pro pro-label small"
};
const _hoisted_48 = ["disabled"];
const _hoisted_49 = {
    class: "oplus-form-text",
    for: "role-modal-external-id"
};
const _hoisted_50 = { class: "form-padding role-form-footer m-0" };
const _hoisted_51 = {
    key: 1,
    class: "text-error"
};
const _hoisted_52 = { class: "accordion role-details" };
const _hoisted_53 = { class: "accordion-body" };
const _hoisted_54 = { class: "form-padding" };
const _hoisted_55 = { class: "accordion-body mb-0" };
const _hoisted_56 = { class: "form-padding" };
const _hoisted_57 = { class: "form-padding role-form-footer m-0" };
const _hoisted_58 = ["disabled"];
const _hoisted_59 = { class: "accordion role-details" };
const _hoisted_60 = { class: "accordion-body" };
const _hoisted_61 = { class: "form-padding" };
const ColorBox_vue_1 = __importDefault(require("../../vue/ColorBox.vue"));
const RolesTable_vue_1 = __importDefault(require("../../vue/RolesTable.vue"));
const SaveConfirmModal_vue_1 = __importDefault(require("../../vue/components/SaveConfirmModal.vue"));
const models_js_1 = require("../../js/models.js");
const roles_js_1 = require("../../js/roles.js");
const common_1 = require("../../common/common");
const common_2 = require("../../js/common");
const slotTypesToString_1 = require("../../common/slotTypesToString");
const vue_3 = require("vue");
const OemSettingsText_1 = require("../../common/OemSettingsText");
const rolesStaffTableTypes_1 = require("../../vue/rolesStaffView/rolesStaffTableTypes");
const RoleRequiredWrapper_vue_1 = __importDefault(require("./RoleRequiredWrapper.vue"));
const SectionList_vue_1 = __importDefault(require("./SectionList.vue"));
const RoleRelationList_vue_1 = __importDefault(require("./RoleRelationList.vue"));
const AlertModal_vue_1 = __importDefault(require("../../vue/AlertModal.vue"));
const BreadCrumArrowIconSmall_vue_1 = __importDefault(require("../../assets/icons/BreadCrumArrowIconSmall.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleDataForm',
    props: {
        isGroupRoleForm: { type: Boolean },
        isGroupOwner: { type: Boolean },
        selectedOem: {},
        hasProPerm: { type: Boolean },
        hasAutoPerm: { type: Boolean },
        hasKot: { type: Boolean },
        hasRolePerm: { type: Boolean },
        branchSettings: {}
    },
    setup(__props) {
        const roleData = (0, vue_3.inject)("roleView");
        const activeUserData = (0, vue_3.inject)('activeUserData');
        const alertModal = (0, vue_3.ref)(null);
        const saveConfirmModal = (0, vue_3.ref)(null);
        const roleRequiredWrapper = (0, vue_3.ref)(null);
        const props = __props;
        const isColorBoxVisible = (0, vue_3.ref)(false);
        const isLoading = (0, vue_3.ref)(false);
        const isRoleRequiredLoading = (0, vue_3.ref)(false);
        const selectedRoleID = (0, vue_3.ref)(0);
        const colorBoxEl = (0, vue_3.ref)(null);
        const roleEditDetails = (0, vue_3.ref)(null);
        const roleRequiredDetails = (0, vue_3.ref)(null);
        const hasUnsavedRoleRequiredChanges = (0, vue_3.ref)(false);
        const savedFormData = (0, vue_3.ref)("");
        const shouldSkipBeforeUnload = (0, vue_3.ref)(false);
        const editSharedSettings = props.isGroupRoleForm && props.isGroupOwner;
        const formData = (0, vue_3.ref)({
            id: 0,
            name: "",
            purpose: "",
            from: "",
            to: "",
            rest: "",
            wage: "",
            isNightShift: false,
            nextDayOff: false,
            showCount: true,
            isCountFixed: false,
            showStaffCount: true,
            color: models_js_1.OPLUS_COLOR_PALETTE.DEFAULT,
            type: rolesStaffTableTypes_1.ROLE_TYPE_INDEX.BY_DAYS,
            slotType: models_js_1.SLOT_TYPES.HOURLY,
            kotHolidayType: "",
            externalID: "",
            isHiddenInShiftPage: false,
            isDisabledWhenFull: false,
            isGroupWide: props.isGroupRoleForm, // always set to true if we are on group-role page
        });
        function updateRoleRef() {
            if (!roleData?.value) {
                return;
            }
            roleData.value.name = formData.value.name;
            roleData.value.purpose = formData.value.purpose;
            roleData.value.from = formData.value.from;
            roleData.value.to = formData.value.to;
            roleData.value.rest = formData.value.rest;
            roleData.value.wage = formData.value.wage;
            roleData.value.isNightShift = formData.value.isNightShift;
            roleData.value.nextDayOff = formData.value.nextDayOff;
            roleData.value.showCount = formData.value.showCount;
            roleData.value.isCountFixed = formData.value.isCountFixed;
            roleData.value.showStaffCount = formData.value.showStaffCount;
            roleData.value.color = formData.value.color ? formData.value.color : models_js_1.OPLUS_COLOR_PALETTE.DEFAULT;
            roleData.value.type = formData.value.type;
            roleData.value.slotType = formData.value.slotType;
            roleData.value.kotHolidayType = formData.value.kotHolidayType;
            roleData.value.externalID = formData.value.externalID;
            roleData.value.isHiddenInShiftPage = formData.value.isHiddenInShiftPage;
            roleData.value.isDisabledWhenFull = formData.value.isDisabledWhenFull;
            roleData.value.isGroupWide = formData.value.isGroupWide;
        }
        function setFormData() {
            const role = roleData?.value;
            if (!role) {
                return;
            }
            formData.value.name = role.name;
            formData.value.purpose = role.purpose;
            formData.value.from = role.from;
            formData.value.to = role.to;
            formData.value.rest = role.rest;
            formData.value.wage = role.wage;
            formData.value.isNightShift = role.isNightShift;
            formData.value.nextDayOff = role.nextDayOff;
            formData.value.showCount = role.showCount;
            formData.value.isCountFixed = role.isCountFixed;
            formData.value.showStaffCount = role.showStaffCount;
            formData.value.color = role.color ? role.color : models_js_1.OPLUS_COLOR_PALETTE.DEFAULT;
            formData.value.type = role.type;
            formData.value.slotType = role.slotType;
            formData.value.kotHolidayType = role.kotHolidayType;
            formData.value.externalID = role.externalID;
            formData.value.isHiddenInShiftPage = role.isHiddenInShiftPage;
            formData.value.isDisabledWhenFull = role.isDisabledWhenFull;
            formData.value.isGroupWide = role.isGroupWide;
            formData.value.roleSections = role.roleSections;
            selectedRoleID.value = role.id;
        }
        function openColorBox() {
            isColorBoxVisible.value = true;
        }
        // Close color box outside click
        function handleRoleContainerClick(event) {
            const target = event.target;
            if (!colorBoxEl.value?.contains(target)) {
                isColorBoxVisible.value = false;
            }
            return;
        }
        function computedRoleTime(value) {
            if (value.length === 3) {
                value = `0${value}`;
            }
            const { hour, min } = (0, common_1.extractTimeAndMin)(value, false);
            if (hour === undefined && min === undefined) {
                return "";
            }
            return `${(0, common_2.addZeroPlaceholders)(hour)}:${(0, common_2.addZeroPlaceholders)(min)}`;
        }
        function handleFromShiftInput(event) {
            const target = event.target;
            const value = target.value;
            formData.value.from = computedRoleTime(value);
        }
        function handleToShiftInput(event) {
            const target = event.target;
            const value = target.value;
            formData.value.to = computedRoleTime(value);
        }
        function handleRestShiftInput(event) {
            const target = event.target;
            const value = target.value;
            formData.value.rest = computedRoleTime(value);
        }
        // emit handler from Colorbox component
        function setSelectedColor(colorStr) {
            return formData.value.color = colorStr;
        }
        // We pass empty string to the request if its a default color
        function setColorDataForSubmit() {
            if (formData.value.color === models_js_1.OPLUS_COLOR_PALETTE.DEFAULT) {
                return "none";
            }
            else {
                return formData.value.color;
            }
        }
        async function handleSubmit() {
            if (isLoading.value) {
                return false;
            }
            if (!formData.value?.name) {
                return false;
            }
            if (formData.value.type === rolesStaffTableTypes_1.ROLE_TYPE_INDEX.EMPLOYEE_COUNT) {
                formData.value.isDisabledWhenFull = false;
            }
            if (formData.value.from) {
                formData.value.from = computedRoleTime(formData.value.from.trim());
            }
            if (formData.value.to) {
                formData.value.to = computedRoleTime(formData.value.to.trim());
            }
            let payload = {};
            if (!selectedRoleID.value) {
                return false;
            }
            if (!isRoleFormDisableInBranchPage.value) {
                payload = {
                    ...formData.value,
                    color: setColorDataForSubmit(),
                    editSharedSettings,
                };
            }
            else {
                payload = {
                    from: formData.value.from,
                    to: formData.value.to
                };
            }
            try {
                isLoading.value = true;
                await (0, roles_js_1.putAndUpdateSharedRoleData)(selectedRoleID.value, payload);
                updateRoleRef();
                (0, common_1.showSaveSuccessSnackbar)();
                updateSavedFormData();
                alertModal.value?.alertSuccess("業務を編集しました。");
                return true;
            }
            catch (err) {
                alertModal.value?.alert("fail to update role");
                return false;
            }
            finally {
                isLoading.value = false;
            }
        }
        function disabledClass(hasPerm) {
            return hasPerm ? "" : "disabled-btn";
        }
        function handleSlotTypeClick(slotType) {
            formData.value.slotType = slotType;
        }
        function handleRoleTypeClick(roleType) {
            formData.value.type = roleType;
        }
        const submitButtonText = (0, vue_3.computed)(() => {
            return selectedRoleID.value ? "保存" : "登録";
        });
        function openSaveConfirmModal(saveCallback, redirectCallback) {
            saveConfirmModal.value?.openModal(saveCallback, redirectCallback, 600);
        }
        function updateSavedFormData() {
            savedFormData.value = serializeFormData();
        }
        function serializeFormData() {
            // Role sections are saved immediately by SectionList, separately from the role form.
            const data = { ...formData.value };
            delete data.roleSections;
            return JSON.stringify(data);
        }
        function hasUnsavedFormChanges() {
            return Boolean(savedFormData.value && serializeFormData() !== savedFormData.value);
        }
        function hasUnsavedChanges() {
            return hasUnsavedFormChanges() || hasUnsavedRoleRequiredChanges.value;
        }
        async function submitAllSavedChanges() {
            if (hasUnsavedFormChanges() && !await handleSubmit()) {
                return false;
            }
            if (hasUnsavedRoleRequiredChanges.value && !await handleRoleRequiredSubmit()) {
                return false;
            }
            return true;
        }
        function redirectWithoutBeforeUnload(url) {
            shouldSkipBeforeUnload.value = true;
            window.location.href = url;
        }
        function handlePageLinkClick(event) {
            const url = (0, common_1.getLinkUrlFromClickEvent)(event);
            if (!url || !hasUnsavedChanges()) {
                return;
            }
            event.preventDefault();
            openSaveConfirmModal(submitAllSavedChanges, () => redirectWithoutBeforeUnload(url));
        }
        function closeRoleEditDetails() {
            if (roleEditDetails.value) {
                roleEditDetails.value.open = false;
            }
        }
        function handleRoleEditSummaryClick(event) {
            if (!roleEditDetails.value?.open || !hasUnsavedFormChanges()) {
                return;
            }
            // Open the save alert modal, if there are unsaved changes when the accordion is closed
            event.preventDefault();
            openSaveConfirmModal(handleSubmit, closeRoleEditDetails);
        }
        function markRoleRequiredChanged() {
            hasUnsavedRoleRequiredChanges.value = true;
        }
        function closeRoleRequiredDetails() {
            roleRequiredWrapper.value?.clearChanges();
            hasUnsavedRoleRequiredChanges.value = false;
            if (roleRequiredDetails.value) {
                roleRequiredDetails.value.open = false;
            }
        }
        async function handleRoleRequiredSubmit() {
            if (isRoleRequiredLoading.value || !roleRequiredWrapper.value) {
                return false;
            }
            try {
                isRoleRequiredLoading.value = true;
                const isSuccess = await roleRequiredWrapper.value.saveChanges();
                if (!isSuccess) {
                    return false;
                }
                hasUnsavedRoleRequiredChanges.value = false;
                (0, common_1.showSaveSuccessSnackbar)();
                return true;
            }
            catch (err) {
                alertModal.value?.alert("エラーが発生しました。恐れ入りますが、再度お試しください。");
                return false;
            }
            finally {
                isRoleRequiredLoading.value = false;
            }
        }
        function handleRoleRequiredSummaryClick(event) {
            if (!roleRequiredDetails.value?.open || !hasUnsavedRoleRequiredChanges.value) {
                return;
            }
            // Open the save alert modal, if there are unsaved changes when the accordion is closed
            event.preventDefault();
            openSaveConfirmModal(handleRoleRequiredSubmit, closeRoleRequiredDetails);
        }
        function handleBeforeUnload(event) {
            if (shouldSkipBeforeUnload.value || !hasUnsavedChanges()) {
                return;
            }
            event.preventDefault();
        }
        const loadingClass = (0, vue_3.computed)(() => {
            return isLoading.value ? "loading" : "";
        });
        const roleRequiredLoadingClass = (0, vue_3.computed)(() => {
            return isRoleRequiredLoading.value ? "loading" : "";
        });
        const selectedColorBox = (0, vue_3.computed)(() => {
            return formData.value.color;
        });
        const colorBoxStyle = (0, vue_3.computed)(() => {
            return {
                backgroundColor: `#${selectedColorBox.value}`,
                borderColor: `#${selectedColorBox.value}`,
            };
        });
        const disableRoleFormInGroupPage = (0, vue_3.computed)(() => {
            return Boolean(selectedRoleID.value && !props.isGroupOwner && roleData?.value?.isGroupWide && props.isGroupRoleForm);
        });
        const isRoleFormDisableInBranchPage = (0, vue_3.computed)(() => {
            return Boolean(selectedRoleID.value && roleData?.value?.isGroupWide && !props.isGroupRoleForm);
        });
        const disableRoleFormInBranchPage = (0, vue_3.computed)(() => {
            return isRoleFormDisableInBranchPage.value ? 'disabled-btn' : '';
        });
        const disableTheDisabledWhenFullOption = (0, vue_3.computed)(() => {
            return formData.value.type === rolesStaffTableTypes_1.ROLE_TYPE_INDEX.EMPLOYEE_COUNT;
        });
        const optionDisabledClass = (0, vue_3.computed)(() => {
            return {
                disabled: formData.value.type === rolesStaffTableTypes_1.ROLE_TYPE_INDEX.EMPLOYEE_COUNT,
            };
        });
        const slotTypes = Object.entries(slotTypesToString_1.slotTypeString);
        const computedActiveUserData = (0, vue_3.computed)(() => {
            return activeUserData || { userId: 0, branchId: 0 };
        });
        const thisRoleStyle = (0, vue_3.computed)(() => {
            return { color: `#${roleData?.value?.color ? roleData.value.color : '8a8a8a'}` };
        });
        const roleName = (0, vue_3.computed)(() => {
            return roleData?.value?.name || "";
        });
        const isNightShift = (0, vue_3.computed)(() => {
            return roleData?.value?.isNightShift || false;
        });
        (0, vue_3.onMounted)(() => {
            setFormData();
            updateSavedFormData();
            document.addEventListener('click', handlePageLinkClick, true);
            window.addEventListener('beforeunload', handleBeforeUnload);
        });
        (0, vue_3.onBeforeUnmount)(() => {
            document.removeEventListener('click', handlePageLinkClick, true);
            window.removeEventListener('beforeunload', handleBeforeUnload);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(AlertModal_vue_1.default, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512 /* NEED_PATCH */),
                (0, vue_2.createVNode)(SaveConfirmModal_vue_1.default, {
                    ref_key: "saveConfirmModal",
                    ref: saveConfirmModal
                }, null, 512 /* NEED_PATCH */),
                (0, vue_2.createElementVNode)("a", {
                    class: "page-title-text d-flex",
                    href: `/dashboard/${computedActiveUserData.value.userId}/roles?c=${computedActiveUserData.value.branchId}`
                }, [
                    _cache[14] || (_cache[14] = (0, vue_2.createTextVNode)("業務管理 ", -1 /* CACHED */)),
                    (0, vue_2.createVNode)(BreadCrumArrowIconSmall_vue_1.default),
                    (0, vue_2.createElementVNode)("span", {
                        style: (0, vue_2.normalizeStyle)(thisRoleStyle.value)
                    }, (0, vue_2.toDisplayString)(roleName.value), 5 /* TEXT, STYLE */)
                ], 8 /* PROPS */, _hoisted_1),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)(RolesTable_vue_1.default, {
                        roles: [formData.value],
                        "is-group-role-form": __props.isGroupRoleForm,
                        "use-for-create-or-edit": true,
                        "branch-settings": __props.branchSettings,
                        "show-time-line": true
                    }, null, 8 /* PROPS */, ["roles", "is-group-role-form", "branch-settings"]),
                    (0, vue_2.createElementVNode)("details", {
                        ref_key: "roleEditDetails",
                        ref: roleEditDetails,
                        class: "accordion role-details role-edit-details"
                    }, [
                        (0, vue_2.createElementVNode)("summary", {
                            class: "accordion-header c-hand",
                            onClick: handleRoleEditSummaryClick
                        }, [...(_cache[15] || (_cache[15] = [
                                (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap px-2" }, [
                                    (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
                                    (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, [
                                        (0, vue_2.createElementVNode)("span", null, "詳細")
                                    ])
                                ], -1 /* CACHED */)
                            ]))]),
                        (0, vue_2.createElementVNode)("form", {
                            onSubmit: (0, vue_2.withModifiers)(handleSubmit, ["prevent"]),
                            onClick: handleRoleContainerClick
                        }, [
                            (0, vue_2.createElementVNode)("div", {
                                class: (0, vue_2.normalizeClass)(["accordion-body mb-0", { 'disabled-btn': disableRoleFormInGroupPage.value }])
                            }, [
                                _cache[39] || (_cache[39] = (0, vue_2.createElementVNode)("div", { class: "role-form-title-divider" }, null, -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["form-padding relative", disableRoleFormInBranchPage.value])
                                }, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_3, [
                                        _cache[16] || (_cache[16] = (0, vue_2.createTextVNode)("ラベル (必須) ", -1 /* CACHED */)),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.value.name) = $event)),
                                            type: "text",
                                            name: "role-name",
                                            id: "",
                                            placeholder: "業務名"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, formData.value.name]
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                        (0, vue_2.createElementVNode)("div", {
                                            ref_key: "colorBoxEl",
                                            ref: colorBoxEl,
                                            class: "role-form-color-wrapper",
                                            onClick: openColorBox
                                        }, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: "role-form-color-box",
                                                style: (0, vue_2.normalizeStyle)(colorBoxStyle.value)
                                            }, null, 4 /* STYLE */),
                                            (0, vue_2.createElementVNode)("span", _hoisted_5, [
                                                _cache[17] || (_cache[17] = (0, vue_2.createTextVNode)("色塗り ", -1 /* CACHED */)),
                                                (0, vue_2.createVNode)(vue_2.Transition, { name: "slide-up" }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)(ColorBox_vue_1.default, {
                                                            class: "oplus-color-box",
                                                            "selected-color": selectedColorBox.value,
                                                            "is-visible": isColorBoxVisible.value,
                                                            onColorSelect: setSelectedColor
                                                        }, null, 8 /* PROPS */, ["selected-color", "is-visible"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ])
                                        ], 512 /* NEED_PATCH */)
                                    ])
                                ], 2 /* CLASS */),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["form-padding", disableRoleFormInBranchPage.value])
                                }, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_6, [
                                        _cache[18] || (_cache[18] = (0, vue_2.createTextVNode)(" 説明 ", -1 /* CACHED */)),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formData.value.purpose) = $event)),
                                            type: "text",
                                            name: "role-purpose",
                                            placeholder: "朝番, レジ"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, formData.value.purpose]
                                        ])
                                    ])
                                ], 2 /* CLASS */),
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (0, vue_2.createElementVNode)("label", _hoisted_10, [
                                                    _cache[19] || (_cache[19] = (0, vue_2.createTextVNode)(" から ", -1 /* CACHED */)),
                                                    (0, vue_2.createElementVNode)("input", {
                                                        value: formData.value.from,
                                                        onChange: handleFromShiftInput,
                                                        type: "text",
                                                        name: "role-from",
                                                        id: "",
                                                        placeholder: "10, 10:00, 1000"
                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_11)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (0, vue_2.createElementVNode)("label", _hoisted_12, [
                                                    _cache[20] || (_cache[20] = (0, vue_2.createTextVNode)(" まで ", -1 /* CACHED */)),
                                                    (0, vue_2.createElementVNode)("input", {
                                                        value: formData.value.to,
                                                        onChange: handleToShiftInput,
                                                        type: "text",
                                                        name: "role-to",
                                                        id: "",
                                                        placeholder: "18, 18:00, 1800"
                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_13)
                                                ])
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", {
                                            class: (0, vue_2.normalizeClass)(["role-flex-child-wrap", disableRoleFormInBranchPage.value])
                                        }, [
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (0, vue_2.createElementVNode)("label", _hoisted_14, [
                                                    _cache[21] || (_cache[21] = (0, vue_2.createTextVNode)(" 休憩時間 ", -1 /* CACHED */)),
                                                    (0, vue_2.createElementVNode)("input", {
                                                        value: formData.value.rest,
                                                        onChange: handleRestShiftInput,
                                                        type: "text",
                                                        name: "role-rest",
                                                        id: "",
                                                        placeholder: "1, 1:30"
                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (0, vue_2.createElementVNode)("label", {
                                                    class: (0, vue_2.normalizeClass)(["oplus-form-number", disabledClass(__props.hasRolePerm)]),
                                                    for: "role-wage"
                                                }, [
                                                    _cache[22] || (_cache[22] = (0, vue_2.createTextVNode)(" 時給 ", -1 /* CACHED */)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formData.value.wage) = $event)),
                                                        type: "number",
                                                        name: "role-wage",
                                                        id: "",
                                                        placeholder: "1000",
                                                        disabled: !__props.hasRolePerm
                                                    }, null, 8 /* PROPS */, _hoisted_16), [
                                                        [vue_2.vModelText, formData.value.wage]
                                                    ])
                                                ], 2 /* CLASS */)
                                            ])
                                        ], 2 /* CLASS */)
                                    ])
                                ]),
                                _cache[40] || (_cache[40] = (0, vue_2.createElementVNode)("span", { class: "form-padding role-form-title accordion-header" }, "設定", -1 /* CACHED */)),
                                _cache[41] || (_cache[41] = (0, vue_2.createElementVNode)("div", { class: "role-form-title-divider sub" }, null, -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["form-padding role-flex-wrapper", disableRoleFormInBranchPage.value])
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                            _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("span", { class: "oplus-form-text" }, "割り当て方法", -1 /* CACHED */)),
                                            (!__props.hasAutoPerm)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_19, [...(_cache[23] || (_cache[23] = [
                                                        (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-lock zmdi-hc-lg" }, null, -1 /* CACHED */)
                                                    ]))]))
                                                : (0, vue_2.createCommentVNode)("v-if", true)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", {
                                            class: (0, vue_2.normalizeClass)(["role-flex-wrapper", disabledClass(__props.hasAutoPerm)]),
                                            "data-columns": "2"
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                                    (0, vue_2.createElementVNode)("span", _hoisted_22, (0, vue_2.toDisplayString)((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_TEXT)[formData.value.type ?? (0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).BY_DAYS]), 1 /* TEXT */),
                                                    _cache[25] || (_cache[25] = (0, vue_2.createElementVNode)("svg", { class: "svg-header-dimension-down-arrow" }, [
                                                        (0, vue_2.createElementVNode)("use", { "xlink:href": "/static/dashboard/oplus_custom_icons-1.svg#down-arrow-icon" })
                                                    ], -1 /* CACHED */))
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                                        (0, vue_2.createElementVNode)("span", {
                                                            class: "shift-select-dropdown-item",
                                                            onClick: _cache[3] || (_cache[3] = ($event) => (handleRoleTypeClick((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).BY_DAYS)))
                                                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_TEXT)[(0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).BY_DAYS]), 1 /* TEXT */),
                                                        (0, vue_2.createElementVNode)("span", {
                                                            class: "shift-select-dropdown-item",
                                                            onClick: _cache[4] || (_cache[4] = ($event) => (handleRoleTypeClick((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).EMPLOYEE_COUNT)))
                                                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_TEXT)[(0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).EMPLOYEE_COUNT]), 1 /* TEXT */)
                                                    ])
                                                ])
                                            ])
                                        ], 2 /* CLASS */)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_25, [
                                        _cache[27] || (_cache[27] = (0, vue_2.createElementVNode)("div", { class: "role-setting-header" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "oplus-form-text" }, "シフトの種類")
                                        ], -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                                    (0, vue_2.createElementVNode)("span", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(slotTypesToString_1.slotTypeString)[formData.value.slotType || 0]), 1 /* TEXT */),
                                                    _cache[26] || (_cache[26] = (0, vue_2.createElementVNode)("svg", { class: "svg-header-dimension-down-arrow" }, [
                                                        (0, vue_2.createElementVNode)("use", { "xlink:href": "/static/dashboard/oplus_custom_icons-1.svg#down-arrow-icon" })
                                                    ], -1 /* CACHED */))
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(slotTypes), (slotType) => {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                                class: "shift-select-dropdown-item",
                                                                onClick: ($event) => (handleSlotTypeClick(parseInt(slotType[0])))
                                                            }, (0, vue_2.toDisplayString)(slotType[1]), 9 /* TEXT, PROPS */, _hoisted_32));
                                                        }), 256 /* UNKEYED_FRAGMENT */))
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])
                                ], 2 /* CLASS */),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["form-padding role-flex-wrapper", disableRoleFormInBranchPage.value])
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                        _cache[32] || (_cache[32] = (0, vue_2.createElementVNode)("div", { class: "role-setting-header" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "oplus-form-text" }, "シフト表に表示(業務)")
                                        ], -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_34, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                                (0, vue_2.createElementVNode)("label", _hoisted_36, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((formData.value.showCount) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-show-count"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [vue_2.vModelCheckbox, formData.value.showCount]
                                                    ]),
                                                    _cache[28] || (_cache[28] = (0, vue_2.createTextVNode)(" カウント ", -1 /* CACHED */))
                                                ]),
                                                (0, vue_2.createElementVNode)("label", _hoisted_37, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((formData.value.isCountFixed) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-fix-count"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [vue_2.vModelCheckbox, formData.value.isCountFixed]
                                                    ]),
                                                    _cache[29] || (_cache[29] = (0, vue_2.createTextVNode)(" カウント行を固定 ", -1 /* CACHED */))
                                                ]),
                                                (0, vue_2.createElementVNode)("label", _hoisted_38, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((formData.value.showStaffCount) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-show-staff-count"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [vue_2.vModelCheckbox, formData.value.showStaffCount]
                                                    ]),
                                                    _cache[30] || (_cache[30] = (0, vue_2.createTextVNode)(" 割当 ", -1 /* CACHED */))
                                                ]),
                                                (0, vue_2.createElementVNode)("label", _hoisted_39, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((formData.value.isHiddenInShiftPage) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-hidden-in-shift-page"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [vue_2.vModelCheckbox, formData.value.isHiddenInShiftPage]
                                                    ]),
                                                    _cache[31] || (_cache[31] = (0, vue_2.createTextVNode)(" シフト提出ページに非表示 ", -1 /* CACHED */))
                                                ])
                                            ])
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)(["role-flex-child-wrap flex-column", disableRoleFormInBranchPage.value])
                                    }, [
                                        _cache[36] || (_cache[36] = (0, vue_2.createElementVNode)("div", { class: "role-setting-header" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "oplus-form-text" }, "その他")
                                        ], -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_40, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_41, [
                                                (__props.isGroupRoleForm)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                                        key: 0,
                                                        class: (0, vue_2.normalizeClass)(["oplus-form-checkbox", { 'disabled-btn': Boolean(__props.isGroupRoleForm || selectedRoleID.value) }])
                                                    }, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((formData.value.isGroupWide) = $event)),
                                                            type: "checkbox",
                                                            id: "role-modal-groupwide"
                                                        }, null, 512 /* NEED_PATCH */), [
                                                            [vue_2.vModelCheckbox, formData.value.isGroupWide]
                                                        ]),
                                                        _cache[33] || (_cache[33] = (0, vue_2.createTextVNode)(" 他拠点へ同期 ", -1 /* CACHED */))
                                                    ], 2 /* CLASS */))
                                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                                (0, vue_2.createElementVNode)("label", {
                                                    class: (0, vue_2.normalizeClass)(["oplus-form-checkbox", optionDisabledClass.value])
                                                }, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((formData.value.isDisabledWhenFull) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-disabled-when-full",
                                                        disabled: disableTheDisabledWhenFullOption.value
                                                    }, null, 8 /* PROPS */, _hoisted_42), [
                                                        [vue_2.vModelCheckbox, formData.value.isDisabledWhenFull]
                                                    ]),
                                                    _cache[34] || (_cache[34] = (0, vue_2.createTextVNode)(" 必要人数を満たしている場合無効 ", -1 /* CACHED */))
                                                ], 2 /* CLASS */),
                                                (0, vue_2.createElementVNode)("label", _hoisted_43, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((formData.value.nextDayOff) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-nextdayoff"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [vue_2.vModelCheckbox, formData.value.nextDayOff]
                                                    ]),
                                                    _cache[35] || (_cache[35] = (0, vue_2.createTextVNode)(" 次の日休み ", -1 /* CACHED */))
                                                ])
                                            ])
                                        ])
                                    ], 2 /* CLASS */)
                                ], 2 /* CLASS */),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["role-flex-wrapper form-padding", disableRoleFormInBranchPage.value])
                                }, [
                                    (0, vue_2.createElementVNode)("div", null, [
                                        (0, vue_2.createElementVNode)("label", _hoisted_44, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_45, [
                                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(OemSettingsText_1.selectedOemText)[props?.selectedOem || 0]), 1 /* TEXT */),
                                                _cache[37] || (_cache[37] = (0, vue_2.createElementVNode)("span", null, "連携", -1 /* CACHED */)),
                                                (!__props.hasKot && __props.hasProPerm)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_46))
                                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                                (!__props.hasProPerm)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_47))
                                                    : (0, vue_2.createCommentVNode)("v-if", true)
                                            ]),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((formData.value.kotHolidayType) = $event)),
                                                id: "role-modal-holiday-type",
                                                type: "number",
                                                placeholder: "休暇区分コード",
                                                disabled: !__props.hasKot
                                            }, null, 8 /* PROPS */, _hoisted_48), [
                                                [vue_2.vModelText, formData.value.kotHolidayType]
                                            ])
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", null, [
                                        (0, vue_2.createElementVNode)("label", _hoisted_49, [
                                            _cache[38] || (_cache[38] = (0, vue_2.createElementVNode)("span", null, "連携用ID", -1 /* CACHED */)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((formData.value.externalID) = $event)),
                                                type: "text",
                                                id: "role-modal-external-id",
                                                placeholder: "101"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, formData.value.externalID]
                                            ])
                                        ])
                                    ])
                                ], 2 /* CLASS */)
                            ], 2 /* CLASS */),
                            (0, vue_2.createElementVNode)("div", _hoisted_50, [
                                (!disableRoleFormInGroupPage.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        key: 0,
                                        class: (0, vue_2.normalizeClass)([loadingClass.value, "oplus-modal-btn oplus-alt-confirm-btn oplus-save-btn"])
                                    }, (0, vue_2.toDisplayString)(submitButtonText.value), 3 /* TEXT, CLASS */))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_51, "オーナーのみ設定を編集できます"))
                            ])
                        ], 32 /* NEED_HYDRATION */)
                    ], 512 /* NEED_PATCH */),
                    (0, vue_2.createElementVNode)("details", _hoisted_52, [
                        _cache[43] || (_cache[43] = (0, vue_2.createElementVNode)("summary", { class: "accordion-header c-hand" }, [
                            (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap px-2" }, [
                                (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
                                (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, "セクション")
                            ])
                        ], -1 /* CACHED */)),
                        (0, vue_2.createElementVNode)("div", _hoisted_53, [
                            _cache[42] || (_cache[42] = (0, vue_2.createElementVNode)("div", { class: "role-form-title-divider" }, null, -1 /* CACHED */)),
                            (0, vue_2.createElementVNode)("div", _hoisted_54, [
                                (0, vue_2.createVNode)(SectionList_vue_1.default)
                            ])
                        ])
                    ]),
                    (selectedRoleID.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("details", {
                            key: 0,
                            ref_key: "roleRequiredDetails",
                            ref: roleRequiredDetails,
                            class: "accordion role-details"
                        }, [
                            (0, vue_2.createElementVNode)("summary", {
                                class: "accordion-header c-hand",
                                onClick: handleRoleRequiredSummaryClick
                            }, [...(_cache[44] || (_cache[44] = [
                                    (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap px-2" }, [
                                        (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
                                        (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, "割り当て方法の詳細設定")
                                    ], -1 /* CACHED */)
                                ]))]),
                            (0, vue_2.createElementVNode)("div", _hoisted_55, [
                                (0, vue_2.createElementVNode)("div", _hoisted_56, [
                                    (0, vue_2.createVNode)(RoleRequiredWrapper_vue_1.default, {
                                        ref_key: "roleRequiredWrapper",
                                        ref: roleRequiredWrapper,
                                        "has-auto-perm": __props.hasAutoPerm,
                                        onChange: markRoleRequiredChanged
                                    }, null, 8 /* PROPS */, ["has-auto-perm"])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_57, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn oplus-save-btn", roleRequiredLoadingClass.value]),
                                    disabled: isRoleRequiredLoading.value,
                                    onClick: handleRoleRequiredSubmit
                                }, "変更を保存", 10 /* CLASS, PROPS */, _hoisted_58)
                            ])
                        ], 512 /* NEED_PATCH */))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("details", _hoisted_59, [
                        _cache[45] || (_cache[45] = (0, vue_2.createElementVNode)("summary", { class: "accordion-header c-hand" }, [
                            (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap px-2" }, [
                                (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
                                (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, "業務グループ")
                            ])
                        ], -1 /* CACHED */)),
                        (0, vue_2.createElementVNode)("div", _hoisted_60, [
                            (0, vue_2.createElementVNode)("div", _hoisted_61, [
                                (0, vue_2.createVNode)(RoleRelationList_vue_1.default)
                            ])
                        ])
                    ])
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
